/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import React from "react";
import SearchRefineMultiSelect from "~components/organisms/search/search_refine_multi_select/search_refine_multi_select";
import jobSearchRefineSelectLocationStyles from "./search_jobs_refine_select_location.styles";
import ReactSelectFlagIconMultiValue from "./sub_components/react_select_flag_icon_multi_value/react_select_flag_icon_multi_value";
import SearchRefineMultiSelectCheckboxOptionFlag from "./sub_components/search_refine_multi_select_checkbox_option_flag/search_refine_multi_select_checkbox_option_flag";

const OFFICE_SELECT_CUSTOM_COMPONENTS = {
  Option: SearchRefineMultiSelectCheckboxOptionFlag,
  MultiValue: ReactSelectFlagIconMultiValue,
};

const PLACEHOLDER_STRING = "Choose a location...";

const SearchJobsRefineSelectLocation = ({ ...rest }) => {
  return (
    <SearchRefineMultiSelect
      styles={jobSearchRefineSelectLocationStyles}
      customComponents={OFFICE_SELECT_CUSTOM_COMPONENTS}
      placeholder={PLACEHOLDER_STRING}
      {...rest}
    />
  );
};
export default SearchJobsRefineSelectLocation;
